import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { routes } from 'app/routing/routesConfig';
import { useIsMobile } from 'app/utils/hooks';
import { LocationStateType } from 'types/generic.types';
import { useAppSelector } from 'app/store';
import { getAuthenticatedSelector } from 'app/store/Auth/selectors';

// Component which:
// Renders the content if the user is unauthenticated
// Otherwise redirects user to landing page (songs or where the user came from on desktop, settings on mobile)
export const PublicRoute = ({ children }) => {
  const isAuthenticated = useAppSelector(getAuthenticatedSelector);
  const isMobile = useIsMobile();
  const { state: locationState, search } = useLocation();

  const redirectPath = isMobile
    ? routes.settings.path
    : (locationState as LocationStateType)?.from || routes.songs.path;

  if (isAuthenticated) {
    return (
      <Navigate
        to={{ pathname: redirectPath, search }}
        state={locationState}
        replace
      />
    );
  }

  return children || <Outlet />;
};
